import React from 'react'
import VideoCard from './VideoCard'

const IntroVideos = ({ plan, introVideo, previewEntry }) => {
  return (
    <>
      {plan.singleClass && (introVideo?.length > 0 || previewEntry) && (
        <>
          <div className='workout-neighbor-info' id='workout-neighbor-info'>
            {introVideo?.length > 0 && (
              <div
                className='entry-neighbor'
                data-toggle='modal'
                data-target='#preview-modal'
              >
                <h2>Class Intro</h2>
                <VideoCard video={introVideo?.[0]?.video} />
              </div>
            )}
            {previewEntry && (
              <div
                className='entry-neighbor'
                data-toggle='modal'
                data-target='#3-min-modal'
              >
                <h2>Preview</h2>
                <VideoCard video={previewEntry} />
              </div>
            )}
          </div>
        </>
      )}
    </>
  )
}

export default IntroVideos
